/**
 * BackgroundMusicPageV2 — redesigned Background Music list shell, port
 * of the prototype's `.screen-bgm` page-head
 * (cms-redesign-mockup.html ~7245–7256).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import BackgroundMusicTableV2 from './v2/BackgroundMusicTableV2';
import { PageHeader, Button } from '../../redesign';

const PlusSign = (
  <span style={{ fontSize: 16, lineHeight: 1 }} aria-hidden>+</span>
);

export default function BackgroundMusicPageV2() {
  const total = useSelector((s) =>
    Array.isArray(s.background_musics.background_musics)
      ? s.background_musics.background_musics.length
      : undefined,
  );
  const totalLabel = total != null ? `${total.toLocaleString()} total` : undefined;

  return (
    <div className="bg-bg min-h-full">
      <PageHeader
        eyebrow="Content Assets"
        title="Background Music"
        total={totalLabel}
        actions={
          <Link to="/background-musics/add" className="no-underline">
            <Button variant="coral" leadingIcon={PlusSign}>
              Add Background Music
            </Button>
          </Link>
        }
      />
      <BackgroundMusicTableV2 />
    </div>
  );
}
